module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/megaphone-efd271ab25ef3f9e907791e101b02a7a.png";